const FooterData = {
    siteInfo: [
        {
            id: 1,
            aboutText: "We make registering, hosting, and managing domains for yourself or others easy and affordable, because the internet needs people.",
            image: 'logo.png'
        }
    ],

    socialIcon:[
        {
          id: 1,
          url: 'https://www.facebook.com/',
          icon: 'fab fa-facebook-f',
        },
        {
          id: 2,
          url: '.#',
          icon: 'fab fa-twitter',
        },
        {
          id: 3,
          url: '.#',
          icon: 'fab fa-dribbble',
        },
        {
          id: 4,
          url: '.#',
          icon: 'fab fa-linkedin-in',
        },
        {
          id: 5,
          url: '.#',
          icon: 'fab fa-github',
        }
    ],
    singleWidget: [
        {
            id: 1,
            title:"Hosting",
            menuItems: [
                {
                    id:1,
                    url:".#",
                    title:"Shared Hosting"
                },
                {
                    id:2,
                    url:".#",
                    title:"WordPress Hosting"
                },
                {
                    id:3,
                    url:".#",
                    title:"Reseller Hosting"
                },
                {
                    id:4,
                    url:".#",
                    title:"VPS Hosting"
                },
                {
                    id:5,
                    url:".#",
                    title:"Dedicated Servers"
                },
                {
                    id:6,
                    url:".#",
                    title:"Private Email Hosting"
                }
            ]
        },
        {
            id: 2,
            title:"Domains",
            menuItems: [
                {
                    id:1,
                    url:".#",
                    title:"Domain Name Search"
                },
                {
                    id:2,
                    url:".#",
                    title:"Transfer"
                },
                {
                    id:3,
                    url:".#",
                    title:"Personal Domain"
                },
                {
                    id:4,
                    url:".#",
                    title:"Whois Lookup"
                },
                {
                    id:5,
                    url:".#",
                    title:"PremiumDNS"
                },
                {
                    id:6,
                    url:".#",
                    title:"FreeDNS"
                }
            ]
        },
        {
            id: 3,
            title:"Support",
            menuItems: [
                {
                    id:1,
                    url:".#",
                    title:"Support Center"
                },
                {
                    id:2,
                    url:".#",
                    title:"Status Updates"
                },
                {
                    id:3,
                    url:".#",
                    title:"Knowledgebase"
                },
                {
                    id:4,
                    url:".#",
                    title:"Submit Ticket"
                },
                {
                    id:5,
                    url:".#",
                    title:"Live Chat"
                },
                {
                    id:6,
                    url:".#",
                    title:"Privacy Policy"
                }
            ]
        }
    ],

    paymentSupport:[
        {
          id: 1,
          icon: 'fab fa-cc-paypal',
        },
        {
          id: 2,
          icon: 'fab fa-cc-stripe',
        },
        {
          id: 3,
          icon: 'fab fa-cc-mastercard',
        },
        {
          id: 4,
          icon: 'fab fa-cc-jcb',
        },
        {
          id: 5,
          icon: 'fab fa-cc-amazon-pay',
        },
        {
          id: 6,
          icon: 'fab fa-cc-amex',
        },
        {
          id: 7,
          icon: 'fab fa-cc-visa',
        }
    ],

    copyright: "Copyright © 2020. All Rights Reserved To Klaud Ltd.",

}


export default FooterData
